import {
	GET_USERS_SUCCESS,
	ADD_ADMIN_USER,
	GET_PERMISSIONS,
	DELETE_ADMIN_USER,
	UPDATE_ADMIN_USER
} from '../../Actions/Admin/ManageUserActions';

const initialState = {
	users: [],
	permissions: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_USERS_SUCCESS:
			return {
				...state,
				users: action.payload,
				loading: false
			};
		case ADD_ADMIN_USER:
			return {
				...state,
				users: action.payload
			};
		case DELETE_ADMIN_USER:
			return {
				...state,
				users: action.payload
			};
		case GET_PERMISSIONS:
			return {
				...state,
				permissions: action.permissions
			};
		case UPDATE_ADMIN_USER:
			return {
				...state,
				users: action.payload
			};
	
		default:
			return state;
	}
};
